export default function UseCases() {
  const useCases = [
    {
      icon: 'ri-user-star-line',
      title: 'Dirigeants & CEOs',
      description: 'Concentrez-vous sur la vision stratégique pendant que votre assistant gère l\'opérationnel quotidien',
      image: 'https://public.readdy.ai/ai/img_res/66ba187739e9d22e2920dd5a779b9fd7.jpg'
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Cabinets & agences',
      description: 'Optimisez la gestion de vos clients et projets avec une coordination parfaite',
      image: 'https://readdy.ai/api/search-image?query=modern%20consulting%20agency%20office%20with%20multiple%20team%20members%20collaborating%20using%20AI%20technology%20holographic%20displays%20in%20purple%20and%20blue%20tones%20showing%20client%20management%20dashboards%20in%20sleek%20professional%20setting&width=600&height=400&seq=usecase-agency&orientation=landscape'
    },
    {
      icon: 'ri-building-line',
      title: 'Architectes & promoteurs',
      description: 'Gérez vos chantiers, clients et fournisseurs avec une efficacité maximale',
      image: 'https://readdy.ai/api/search-image?query=architect%20working%20with%20futuristic%20AI%20holographic%20building%20plans%20and%20project%20management%20interface%20in%20modern%20office%20with%20purple%20blue%20lighting%20and%20digital%20construction%20visualization%20tools%20in%20premium%20professional%20environment&width=600&height=400&seq=usecase-architect&orientation=landscape'
    },
    {
      icon: 'ri-service-line',
      title: 'Consultants & professions libérales',
      description: 'Automatisez votre administratif et concentrez-vous sur votre expertise',
      image: 'https://readdy.ai/api/search-image?query=professional%20consultant%20in%20elegant%20minimalist%20workspace%20using%20advanced%20AI%20assistant%20technology%20with%20floating%20holographic%20interface%20in%20purple%20and%20blue%20colors%20managing%20multiple%20client%20projects%20in%20sophisticated%20setting&width=600&height=400&seq=usecase-consultant&orientation=landscape'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Entreprises en croissance',
      description: 'Scalez votre organisation sans multiplier les embauches administratives',
      image: 'https://readdy.ai/api/search-image?query=dynamic%20startup%20office%20environment%20with%20growth%20charts%20and%20AI%20technology%20holographic%20displays%20in%20purple%20blue%20gradient%20showing%20business%20expansion%20and%20team%20collaboration%20in%20modern%20innovative%20workspace&width=600&height=400&seq=usecase-startup&orientation=landscape'
    }
  ];

  return (
    <section id="cas-usage" className="py-24 px-6 relative">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-blue-600/10 border border-blue-500/30 rounded-full mb-6">
            <span className="text-sm text-blue-300 whitespace-nowrap">Cas d'usage</span>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Adapté à votre
            <br />
            <span className="bg-gradient-to-r from-violet-400 to-blue-400 bg-clip-text text-transparent">
              réalité professionnelle
            </span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Quelle que soit votre industrie, AI Exécutif Assistant s'adapte à vos besoins spécifiques.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {useCases.slice(0, 3).map((useCase, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-white/5 to-white/[0.02] backdrop-blur-sm border border-white/10 rounded-xl overflow-hidden hover:border-blue-500/50 transition-all group cursor-pointer"
            >
              <div className="relative h-48 w-full overflow-hidden">
                <img 
                  src={useCase.image} 
                  alt={useCase.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0f] via-[#0a0a0f]/50 to-transparent"></div>
              </div>
              <div className="p-6">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-blue-600/20 to-violet-600/20 rounded-lg mb-4">
                  <i className={`${useCase.icon} text-2xl text-blue-400`}></i>
                </div>
                <h3 className="text-xl font-semibold mb-3">{useCase.title}</h3>
                <p className="text-sm text-gray-400 leading-relaxed">{useCase.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid md:grid-cols-2 gap-8 mt-8 max-w-4xl mx-auto">
          {useCases.slice(3).map((useCase, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-white/5 to-white/[0.02] backdrop-blur-sm border border-white/10 rounded-xl overflow-hidden hover:border-blue-500/50 transition-all group cursor-pointer"
            >
              <div className="relative h-48 w-full overflow-hidden">
                <img 
                  src={useCase.image} 
                  alt={useCase.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0f] via-[#0a0a0f]/50 to-transparent"></div>
              </div>
              <div className="p-6">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-blue-600/20 to-violet-600/20 rounded-lg mb-4">
                  <i className={`${useCase.icon} text-2xl text-blue-400`}></i>
                </div>
                <h3 className="text-xl font-semibold mb-3">{useCase.title}</h3>
                <p className="text-sm text-gray-400 leading-relaxed">{useCase.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}